module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAMAAAAPIl6bAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUxpcdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEdoAEZJ3aNYAAAARdFJOUwBzqA8J2N5Xr127Y05F8pAnwQZwSwAAAGdJREFUGNONkUsSgCAMQwvykSIg97+sCoiljI7Z5SXNpgDCaAtEIZ9yBKQLZP+APXOyVeK+iK3ETmTe8VOH7Li3ncCJ7F5hAeL2iyl+7bkefcvl337z2Pt6vFdsD8R43wDSP2CMJIcDe8sJ4ERjNi4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/hongjiantou_icon_rczp.png
// module id = 03u4
// module chunks = 1